export enum RBACPermissions {
  USERS = 'USERS',
  STRATEGIES = 'STRATEGIES',
  RISKS = 'RISKS',
  ORDER_ACTIVITY_ACTION = 'ORDER_ACTIVITY_ACTION',
  BUILD = 'BUILD',
  FLUSH = 'FLUSH',
  PAIRS = 'PAIRS',
}
